import { getStatePricingDisclaimer } from '../api/disclaimers-api';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { KmxContainer } from './KmxContainer';
import { useEffect, useState } from 'react';

interface IStatePricingDisclaimerProps {
    fullStoryPageId: string;
}

const StatePricingDisclaimer = ({ fullStoryPageId }: IStatePricingDisclaimerProps) => {
    const [text, setText] = useState<string>('');
    useEffect(() => {
        getStatePricingDisclaimer().then((text: string) => setText(text));
    }, []);

    return text ? (
        <Box data-fs-section={`${fullStoryPageId}: Pricing Disclaimer`}>
            <KmxContainer maxWidth="xl" sx={{ pt: { xs: 8, md: 12 } }}>
                <Typography variant="caption" color="textSecondary" component="div">
                    * {text}
                </Typography>
            </KmxContainer>
        </Box>
    ) : null;
};

export default StatePricingDisclaimer;
